module.exports = __webpack_public_path__ + "e5b30c573da2da8f6579c4c3b82516f1.png";